<template>
    <div class="pb-5">
        <top-bar activeTab="campaign"
                 :lbl="lbl"
                 :profile="profile"
                 :isLogin="isLogin"
                 :leftLogo="true"
                 @switchLang="switchLang($event)"
                 @logout="logout()"></top-bar>

        <div class="user-point" v-html="point"></div>

        <div class="giftlist-cate-wrapper">
            <div class="sub-header cate-item"
                @click="clickMenu('gift')"
                :class="{'active': activeTap == 'gift'}">
                <div v-html="lbl.reward.gift_list"></div>
                <div v-if="activeTap == 'gift'"> <img class="icon-active" src="@/assets/icon/border-active-2x.png" /> </div>
            </div>

            <div class="sub-header cate-item"
                @click="clickMenu('mybookings')"
                :class="{'active': activeTap == 'mybookings'}">
                <div v-html="lbl.reward.history"></div>
                <div v-if="activeTap == 'mybookings'"> <img class="icon-active" src="@/assets/icon/border-active-2x.png" /> </div>
            </div>

            <div class="sub-header cate-item"
                @click="clickMenu('privilege')"
                :class="{'active': activeTap == 'privilege'}">
                <div v-html="lbl.reward.free_gift_list"></div>
                <div v-if="activeTap == 'privilege'"> <img class="icon-active" src="@/assets/icon/border-active-2x.png" /> </div>
            </div>

            <div class="sub-header cate-item"
                @click="clickMenu('myprivilege')"
                :class="{'active': activeTap == 'myprivilege'}">
                <div v-html="lbl.reward.gift_list_history"></div>
                <div v-if="activeTap == 'myprivilege'"> <img class="icon-active" src="@/assets/icon/border-active-2x.png" /> </div>
            </div>
        </div>
        <div id="reward" class="container" v-if="activeTap == 'gift'">
            <GiftList
                :lbl="lbl"
                :isLoading='isLoading'
                :initListConfig="listConfig"
                :initFilterConfig="filterConfig"
                :busEvent="busCampaign"
                :tracking="tracking"
                @toggleLoading="toggleLoading($event)"
                v-if="isLoadedConfig">
            </GiftList>

        </div>
        <div class="container" v-if="activeTap == 'mybookings'">
            <PurchaseList
                :lbl="lbl"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
                :busEvent="busHistory"
                :isLoading="isLoading"
                :tracking="tracking"
                @updatePoint="callApiGetPoint($event)"
                @toggleLoading="toggleLoading($event)"
            ></PurchaseList>
        </div>
        <div id="reward" class="container" v-if="activeTap == 'privilege'">
            <FreeGiftList
                :lbl="lbl"
                :isLoading='isLoading'
                :initListConfig="freeGiftlistConfig"
                :initFilterConfig="freeGiftfilterConfig"
                :busEvent="busCampaign"
                :tracking="tracking"
                @toggleLoading="toggleLoading($event)"
                v-if="isLoadedConfig">
            </FreeGiftList>

        </div>
        <div class="container" v-if="activeTap == 'myprivilege'">
            <FreeGiftHistoryList
                :lbl="lbl"
                :listConfig="freeGiftHistoryConfig"
                :filterConfig="freeGiftHistoryFilterListConfig"
                :busEvent="busHistory"
                :isLoading="isLoading"
                :tracking="tracking"
                @updatePoint="callApiGetPoint($event)"
                @toggleLoading="toggleLoading($event)"
            ></FreeGiftHistoryList>
        </div>
        <menu-bar :currentTab="currentPage"></menu-bar>
    </div>
</template>
<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper";

import TopBar from '@/components/TopBar.vue';
//import DefaultLayout from "@/components/campaign/layout/Default.vue";
import GiftList from "./compomemts/GiftList.vue";
import FreeGiftList from "./compomemts/FreeGiftList.vue";
import {
    CampaignConfigBuilder,
    CampaignListConfigBuilder
} from "@/service/config/CampaignConfigModel.js";
import {
    CategoryConfigBuilder
} from "@/service/config/CategoryConfigModel.js";
import MenuBar from "@/components/MenuBar.vue";
import DiorApi from "@/service/dior/DiorApi.js";
import DateTimeHelper from "../../../../helper/DatetimeHelper.js";
import PurchaseList from "./compomemts/PurchaseList.vue";
import FreeGiftHistoryList from './compomemts/FreeGiftHistoryList.vue';
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from "@/service/config/HistoryConfigModel.js";
import LineFunction from '@/helper/facade/LineFunction.js';

export default {
    name: "Reward",
    components: {
        TopBar,
        //DefaultLayout,
        GiftList,
        FreeGiftList,
        MenuBar,
        PurchaseList,
        FreeGiftHistoryList,
    },
    data: function() {
        return {
            currentPage:"giftlist",
            isLogin: false,
            isLoading: false,
            user: {},
            profile: {},
            profileDior: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            campaignId: '',
            campaign: null,
            campaignConfig: null,
            //Campaignlist
            strConfigList: 'campaign_dior_giftreservation',
            strFreeGiftConfigList: 'campaign_dior_freegift',
            isLoadedConfig: false,
            listConfig: {},
            filterConfig: {},
            freeGiftlistConfig: {},
            freeGiftfilterConfig: {},
            busCampaign: new Vue(),
            busHistory: new Vue(),
            busCategory: new Vue(),
            //point
            userPoint: '1000250',
            expireDatePoint: '',
            isInternetConnected: false,
            point: "",
            activeTap: 'gift',

            purchaseListConfig: {},
            purchaseFilterListConfig: {},
            freeGiftHistoryConfig: {},
            freeGiftHistoryFilterListConfig: {},
            memberProfile: "",
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
            this.profileDior = Account.getCacheDiorProfile();
        });

        var tap = this.$route.params.tap;
        if (tap) {
            this.activeTap = tap;
        }

        this.initialConfig();
        //this.getCampaign();
        this.initialCampaign();
        this.initialCategory();

        this.tracking.screenName('Reward');
    },
    mounted: function() {
          this.checkIsAlreadyRegister((result) => {
            if (result) {

                this.callApiGetPoint();
                // go profile

            } else {
                this.$router.push('/register');
            }
        });
    },
    methods: {
        initialConfig: function () {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        initialCategory: function () {
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig("menu_dior_service")
                .setLocale(this.locale);

            this.categoryConfig = categoryConfig.create();
        },
        getCampaign: function() {
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((result) => {
                this.campaign = result;
                this.isLoaded = true;
            }).catch((error) => {
                console.log(error);
            });
        },
        initialCampaign: function() {
            // campaign List
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.strConfigList)
                .setTop(25)
                .create();
            this.listConfig = listConfig;

            var freeGiftlistConfig = new CampaignListConfigBuilder()
                .setConfigList(this.strFreeGiftConfigList)
                .setTop(25)
                .create();
            this.freeGiftlistConfig = freeGiftlistConfig;

            var freegiftHistoryConfig = new PurchaseListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.purchaseListConfig)
                .setTop(5)
                .create();
            this.freeGiftHistoryConfig = freegiftHistoryConfig;

            var filterFreegiftHistoryConfig = new PurchaseFilterConfigBuilder()
                .create();

            this.freeGiftHistoryFilterListConfig = filterFreegiftHistoryConfig;

            this.isLoadedConfig = true;
        },
        callApiGetPoint: function () {
             Account.apiGetPoint().then((result) => {
                var pointUnit = this.lbl.reward.point + (result.points > 1 && Locale.getLocaleCode() == 1033 ? 'S' : '');
                // var pointUnit = this.lbl.reward.point + (parseInt(this.profileDior.bonusPointBalance) > 1 && Locale.getLocaleCode() == 1033 ? 'S' : '');
                var pointExpired = this.lbl.reward.expired_date;
                this.point = "<span>" +this.addComma(result.points) + "</span> " + pointUnit + "<br>" + pointExpired + " " + DateTimeHelper.dateStringToFormat(this.memberProfile.ExpiryDate);

            }).catch ((error) => {
                console.log(error);
            }) ;
        },

        clickMenu: function (tap) {
            this.listConfig = {};
            this.freeGiftlistConfig = {};
            this.activeTap = tap;
            this.initialCampaign();
            console.log(tap);
            switch (tap) {
                case 'gift':
                   this.tracking.event('Gift_List', 'click_Gift_List');
                   break;
                case 'mybookings':
                   this.tracking.event('Redemtion_history', 'click_Redemtion_history');
                   break;
                case 'privilege':
                   this.tracking.event('Privilege', 'click_Privilege');
                   break;
                case 'myprivilege':
                   this.tracking.event('Privilege_history', 'click_Redemtion_history');
                   break;
            }
        },
        // remove date 15-08-20202 Cell
        // getPointUser: function () {
        //     console.log("getPointUser");
        //     var pointUnit = this.lbl.reward.point + (parseInt(this.profileDior.bonusPointBalance) > 1 && Locale.getLocaleCode() == 1033 ? 'S' : '');
        //     var pointExpired = this.lbl.reward.expired_date;
        //     // return "<span>" + this.addComma(parseInt(this.profileDior.bonusPointBalance)) + "</span> " + pointUnit + "<br>" + pointExpired + " " + this.expireDatePoint;
        //     return "<span>" +this.addComma(this.profileDior.bonusPointBalance) + "</span> " + pointUnit + "<br>" + pointExpired + " " + this.expireDatePoint;
        // },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        switchLang: function(locale) {
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        addComma: function(num){
            if (num) {
                var str = num.toString().split('.');
                if (str[0].length >= 4) {
                    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                }
                return str.join('.');
            } else {
                return "0";
            }

        },
        initLiff: function() {
            return new Promise((resolve) => {
                var lineFunction = new LineFunction();
                this.liffId = lineFunction.getLiffId();

                lineFunction.init(this.liffId).then(() => {

                    this.lineIdToken = lineFunction.getIdToken();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    this.setNotLineRegister();
                    // this.$router.replace('/error');
                });
            });

        },
        checkIsAlreadyRegister: async function(callback) {
            await this.initLiff();
            var token = Account.getToken();
            // var lineUserId = Account.getLineUserId();

            DiorApi.isUserRegistered(token, this.lineIdToken).then((res) => {

                console.log(res.data);
                var isMember = (res.data) ? res.data.IsMember : false;
                this.memberProfile = res.data.Profile.Member;
                if (typeof callback == 'function') {
                    callback(isMember);
                }
            }).catch((err) => {

                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.isInternetConnected = true;
                }

                if (typeof callback == 'function') {
                    callback(false);
                }


            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "./CampaignGift.scss";
</style>

